import React from 'react';
import Modal from 'react-modal';
import BootstrapTable from 'react-bootstrap-table-next';
import ToolkitProvider, { Search } from 'react-bootstrap-table2-toolkit';
import paginationFactory, { PaginationProvider, PaginationListStandalone, PaginationTotalStandalone, SizePerPageDropdownStandalone } from 'react-bootstrap-table2-paginator';

const customTotal = (from, to, size) => (
    <span className="react-bootstrap-table-pagination-total">
        Mostrando {from} a {to} de {size} Resultados
    </span>
);

class modalBusquedaFiltro extends React.Component {
    state = {
        selected: [],
        filtro: ''
    }

    handleOnSelect = (row, isSelect) => {

        this.setState(() => ({
            selected: isSelect ? [row[this.props.id]] : []
        }));

        this.props.selectRow.onSelect(row, isSelect);
    }

    calculasizePerPageList = (cantidad) => {

        if (cantidad <= 15) {
            return [{ text: '5', value: 5 }, { text: '10', value: 10 }, { text: 'Todo', value: cantidad }];
        }

        if (cantidad <= 20) {
            return [{ text: '5', value: 5 }, { text: '10', value: 10 }, { text: '15', value: 15 }, { text: 'Todo', value: cantidad }];
        }

        if (cantidad <= 50) {
            return [{ text: '5', value: 5 }, { text: '10', value: 10 }, { text: '15', value: 15 }, { text: '25', value: 25 }, { text: '35', value: 35 }, { text: 'Todo', value: cantidad }];
        }
        if (cantidad > 50) {
            return [{ text: '5', value: 5 }, { text: '10', value: 10 }, { text: '15', value: 15 }, { text: '25', value: 25 }, { text: '35', value: 35 }, { text: '65', value: 65 }, { text: '85', value: 85 }, { text: '100', value: 100 }, { text: 'Todo', value: cantidad }];
        }

        return [];
    }

    onChangeSearch = (e) => {
        const { value } = e.target;
        this.setState({ filtro: value });
    }

    onClickSearch = (e) => {
        this.props.onClickSearch && this.props.onClickSearch(this.state.filtro);
    }

    render() {
        const { filtro } = this.state;
        const { show, contentLabel, label, id, datos, columnas, striped, hover, condensed, onDoubleClick, clases } = this.props;

        let selectRow = { ...this.props.selectRow };
        selectRow.selected = this.state.selected;
        selectRow.onSelect = this.handleOnSelect;

        const { SearchBar } = Search;
        const _size = datos ? datos.length : 0;
        const _sizePerPageList = this.calculasizePerPageList(_size);
        const _hideSizePerPage = _size === 0;

        let optPaginacion = {
            custom: true,
            paginationSize: 4,
            pageStartIndex: 1,
            alwaysShowAllBtns: true, // Always show next and previous button
            withFirstAndLast: true, // Hide the going to First and Last page button
            hideSizePerPage: _hideSizePerPage,//false, // Hide the sizePerPage dropdown always
            hidePageListOnlyOnePage: true, // Hide the pagination list when only one page
            firstPageText: 'Primero',
            prePageText: 'Anterior',
            nextPageText: 'Siguiente',
            lastPageText: 'Último',
            nextPageTitle: 'Primera Página',
            prePageTitle: 'Pre page',
            firstPageTitle: 'Siguinete Página',
            lastPageTitle: 'Última Página',
            showTotal: true,
            paginationTotalRenderer: customTotal,
            sizePerPageList: _sizePerPageList,
            variation: 'dropup',
            dataSize: _size
        };

        const customStyles = {
            content: {
                position: 'fixed',
                position: 'absolute',
                top: '25%',
                left: '25%',
                right: '25%',
                bottom: '25%',
                with: '50%',
                height: '67%',
                padding: '5px',
                zIndex: '3'
            },
            overlay: {
                backgroundColor: 'rgba(0, 0, 0, 0.75)',
            }
        };

        const rowEvents = {
            onDoubleClick: onDoubleClick
        };

        const NoDatos = 'No hay datos que mostrar';

        return <Modal isOpen={show} contentLabel={contentLabel} style={customStyles} ariaHideApp={false}>
            <div>
                <div className="modal-header">
                    <h2 className="modal-title" id="exampleModalLabel">{label}</h2>
                    <button type="button" className="close" data-dismiss="modal" aria-label="Close" onClick={this.props.cerrarModal}>
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div className="modal-body">
                    <ToolkitProvider keyField={id} data={datos} columns={columnas} search>
                        {
                            props => (
                                <div className='col'>
                                    <div className='row'>
                                        <div className="col">
                                            <div className="mb-5 input-group">
                                                <input placeholder="Código o Nombre..." aria-label="buscar por código o nombre" className="form-control" value={filtro} onChange={this.onChangeSearch} />
                                                <div className="input-group-append">
                                                    <button type="button" className="btn btn-outline-secondary" onClick={this.onClickSearch}>
                                                        Buscar
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className='row justify-content-end'>
                                        <div className="col-3">
                                            <SearchBar {...props.searchProps} placeholder="Filtrar en tabla" />
                                        </div>
                                    </div>
                                    <div className="row">
                                        <PaginationProvider pagination={paginationFactory(optPaginacion)}>
                                            {
                                                ({ paginationProps, paginationTableProps }) => (
                                                    <div className='col'>
                                                        <div className='table-responsive'>
                                                            <BootstrapTable
                                                                {...props.baseProps}
                                                                {...paginationTableProps}
                                                                striped={striped}
                                                                hover={hover}
                                                                condensed={condensed}
                                                                selectRow={selectRow}
                                                                rowEvents={rowEvents}
                                                                className={clases}
                                                                noDataIndication={NoDatos}
                                                            />
                                                        </div>
                                                        <SizePerPageDropdownStandalone {...paginationProps} />
                                                        <PaginationTotalStandalone {...paginationProps} />
                                                        <PaginationListStandalone {...paginationProps} />
                                                    </div>
                                                )
                                            }
                                        </PaginationProvider>
                                    </div>
                                </div>
                            )
                        }
                    </ToolkitProvider>
                </div>
                <div className="modal-footer">
                    <div className="tooltip2">
                        <span className="tooltiptext2">Cerrar</span>
                        <button type="button" className="btn btn-secondary" data-dismiss="modal" onClick={this.props.cerrarModal}>Cerrar</button>
                    </div>
                    <div className="tooltip2">
                        <span className="tooltiptext2">Seleccionar</span>
                        <button type="button" className="btn btn-primary" onClick={this.props.seleccionModal}>Seleccionar</button>
                    </div>
                </div>
            </div>
        </Modal>;
    }
}

export default modalBusquedaFiltro;